
const TiassistoElement = ({ children = <></> }: { children: any }) => {
    return process.env.REACT_APP_TIASSISTO_ENABLED === '1' && children ? { ...children } : <></>
}

export default TiassistoElement;